define([
    'internal_util/Logger',
	'internal_util/Util',
	'internal_util/Configuration',
	'model/Error',
	'model/ErrorType',
	'service/EventListenerRegistry',
    'amdi18n-loader?!service/nls/SessionManager_strings',
	'lib/jquery'
], function (
        Logger,
		Util,
		Configuration,
		Error,
		ErrorType,
        EventListenerRegistry,
		Strings,
		jQuery
		) {
	'use strict';

    return new function () {

		function log(method, message, data) {
			Logger.log('SessionManager', method, message, data);
		}

        function callLog(method, message, data, event, callbacks) {
			log(method, message, data);
			EventListenerRegistry.callListeners(event, data, function () {
				Util.callCallbacks(callbacks, data);
			});
		}

        this.claimSession = function (brokerToken, callbacks, errorCallbacks) {
            var _name = 'claimSession';
            var sessionClaimUrl = Configuration.get('SESSION_CLAIM_URL') + '?broker-token=' + brokerToken;

            callLog(_name, Strings.session_claim_started, sessionClaimUrl, 'SESSION_CLAIM_STARTED', function () {
                jQuery.ajax({
                    url: sessionClaimUrl,
                    type: 'POST',
                    success: function (authFlowResponse) {
                        var authFlowId = authFlowResponse["flowId"];
                        callLog(_name, Strings.session_claim_succeeded, authFlowId, 'SESSION_CLAIM_SUCCEEDED', callbacks);
                    },
                    error: function (jqXHR) {
                        var error;

                        if (jqXHR.status === 404) {
                            error = new Error(ErrorType.RECOVERABLE, Strings.session_claim_failed, Util.toString(jqXHR));
                        } else {
                            error = new Error(ErrorType.NON_RECOVERABLE, Strings.session_claim_failed, Util.toString(jqXHR));
                        }

                        callLog(_name, Strings.session_claim_failed, error, 'SESSION_CLAIM_FAILED', errorCallbacks);
                    }
                });
            });
        };
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/SessionManager.js
// module id = 142
// module chunks = 4